export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/et.lyaml"));
at({ "et": { "public": { "sampleString": "N\xE4idisstring" } } });
};